import axios from "axios";
let instance;
class RefreshToken {
	constructor() {
		this.isRefreshing = false;
		this.refreshPromise = null;
	}
	static get getInstance() {
		if (!instance) {
			instance = new RefreshToken();
		}
		return instance;
	}

	refresh(refresh_token) {
		const rt = this;
		if (!this.refreshPromise) {
			this.refreshPromise = new Promise(resolve => {
				rt.isRefreshing = true;
				let p = '';
				p += 'grant_type=refresh_token';
				p += '&refresh_token=' + refresh_token;
				p += '&client_id=jxch5';
				axios.post('/authUrls/oauth/token', p, {
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded'
					}
				}).then(r => {
					if (r.access_token) {
						r.time = new Date().getTime();
						r.expires_time = new Date().getTime() + r.expires_in * 1000

						localStorage.setItem('login_user_' + window.lm_env, JSON.stringify(r));

						rt.isRefreshing = false;
						rt.refreshPromise = null;
						resolve(r);
						return;
					}
					resolve({});
				}, () => {
					localStorage.clear();
					location.reload();
				})
			});
		}
		return this.refreshPromise;
	}

	addConfig(config, refreshTokenBack) {
		return new Promise(resolve => {
			refreshTokenBack.then(token => {
				config.headers.Authorization = 'Bearer ' + token.access_token;
				resolve(config);
			})
		})
	}
}

export default {
	getInstance: RefreshToken.getInstance
};
